<template>
  <el-card class="box-card">
    <div slot="header" class="detail-head weight-sym" v-if="showHeader">
      <slot name="header"></slot>
    </div>
    <el-row>
      <slot></slot>
    </el-row>
  </el-card>
</template>

<script>
  export default {
    name: 'IonDetailPlus',
    props: {
      labelWidth: {
        type: Number,
        default: 60,
      },
      showColon: {
        type: Boolean,
        default: false,
      },
      align: {
        type: String,
      },
      showHeader: {
        type: Boolean,
        default: true,
      },
    },
    provide() {
      return {
        rootLabelWidth: this.labelWidth,
        rootShowColon: this.showColon,
        rootAlign: this.align,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .box-card {
    padding: var(--theme-block-padding);
    background-color: var(--theme-bg-white);
    border-radius: var(--theme-border-radius-big);
    color: var(--theme-text-primary);
    border: none;
  }
  ::v-deep .el-card__header {
    border: 0;
    padding: 0;
    font-size: var(--theme-font-large);
  }
  ::v-deep .el-card__body {
    padding-bottom: 0;
  }
  .clearfix {
    position: relative;
    padding-left: 10px;
    &::before {
      content: ' ';
      position: absolute;
      width: 5px;
      height: 5px;
      background-color: var(--theme-color-primary);
      border-radius: 5px;
      left: 0;
      top: calc(50% - 2.5px);
    }
  }
</style>
